import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import './Footer.scss';

export const Footer: React.FC = () => {
    return (
        <footer className="app-footer">
            <div className="footer-wave">
                <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
                </svg>
            </div>
            <div className="footer-content-wrapper">
                <div className="footer-top">
                    <div className="footer-content">
                        <div className="footer-section footer-about">
                            <div className="footer-logo">
                                <div className="logo-icon">🍰</div>
                                <h3>Cheesecake İstanbul</h3>
                            </div>
                            <p>30 yıllık tecrübe ile el yapımı, koruyucusuz ve katkısız cheesecake üretiminde öncü firma. B2B müşterilerimize özel toptan satış platformu.</p>
                            <div className="social-links">
                                <a href="https://www.instagram.com/cheesecakeistanbul.tr/" target="_blank" rel="noopener noreferrer" className="social-link instagram">
                                    <span>📸</span>
                                </a>
                                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link facebook">
                                    <span>📘</span>
                                </a>
                                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link twitter">
                                    <span>🐦</span>
                                </a>
                            </div>
                        </div>
                        <div className="footer-section">
                            <h4>Hızlı Linkler</h4>
                            <ul>
                                <li><a href="/">Ana Sayfa</a></li>
                                <li><a href="/products">Ürünler</a></li>
                                <li><a href="/about">Hakkımızda</a></li>
                                <li><a href="/faq">SSS</a></li>
                                <li><a href="/login">Giriş Yap</a></li>
                            </ul>
                        </div>
                        <div className="footer-section">
                            <h4>Kurumsal</h4>
                            <ul>
                                <li><a href="/contact">İletişim</a></li>
                                <li><a href="/privacy">Gizlilik Politikası</a></li>
                                <li><a href="/terms">Kullanım Koşulları</a></li>
                                <li><a href="/kvkk">KVKK</a></li>
                                <li><a href="/register">Kayıt Ol</a></li>
                            </ul>
                        </div>
                        <div className="footer-section footer-contact">
                            <h4>İletişim</h4>
                            <ul className="contact-list">
                                <li>
                                    <MapPin size={18} />
                                    <span>Avcılar, İstanbul</span>
                                </li>
                                <li>
                                    <Phone size={18} />
                                    <a href="tel:+905421098540">0542 109 85 40</a>
                                </li>
                                <li>
                                    <Mail size={18} />
                                    <a href="mailto:info@cheesecakeistanbul.com">info@cheesecakeistanbul.com</a>
                                </li>
                            </ul>
                            <a href="https://wa.me/905421098540" className="whatsapp-btn" target="_blank" rel="noopener noreferrer">
                                <span className="whatsapp-icon">💬</span>
                                WhatsApp Destek
                            </a>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="footer-bottom-content">
                        <p>© 2026 Cheesecake İstanbul. Tüm hakları saklıdır.</p>
                        <div className="footer-badges">
                            <span className="badge">🔒 Güvenli Alışveriş</span>
                            <span className="badge">✓ SSL Sertifikalı</span>
                            <span className="badge">🚚 Hızlı Kargo</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};
